import Actions from './actions';
export const sendAsEmails = (state = {
  loading: true
}, action) => {
  switch (action.type) {
    case Actions.LOAD_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        list: action.payload
      });
    case Actions.ADD_SUCCESS:
      return Object.assign({}, state, {
        list: [
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'list' does not exist on type '{ loading:... Remove this comment to see the full error message
        ...state.list.filter(email => email !== action.payload), action.payload]
      });
    case Actions.DELETE_SUCCESS:
      return Object.assign({}, state, {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'list' does not exist on type '{ loading:... Remove this comment to see the full error message
        list: state.list.filter(email => email !== action.payload)
      });
    case Actions.FAIL:
      return Object.assign({}, state, {
        fail: action.payload
      });
    case Actions.LOAD_FAIL:
      return {
        loading: false,
        loaded: false
      };
    case Actions.CLEAR_FAIL:
      return Object.assign({}, state, {
        fail: undefined
      });
    default:
      return state;
  }
};